/**
 * Created by Andrey Popov on 12/29/25.
 */

const ExtendedCustomerView = cc.Scale9Sprite.extend({
    ctor: function (info) {
        const background = bundles.extended_customer_view.frames.extended_customer_view_bg;
        this._super(background, cleverapps.UI.getScale9Rect(background, cleverapps.UI.Scale9Rect.TwoPixelXY));

        const styles = cleverapps.styles.ExtendedCustomerView;
        this.recipe = info.recipe;
        this.customer = info.customer;

        const pointer = new cc.Sprite(bundles.extended_customer_view.frames.extended_customer_view_tail);
        pointer.setAlignment(styles.pointer);
        this.addChild(pointer);

        this.contentLayout = this.createContent();
        this.addChild(this.contentLayout);
        this.contentLayout.setAlignment(styles.content);
        this.setContentSize2(this.contentLayout);

        this.button = this.createButton();

        this.createHelpButton();

        if (cleverapps.config.debugMode && !this.debugClickHandler) {
            this.debugClickHandler = cleverapps.UI.onClick(this, () => {
                const ingredients = this.recipe.getIngredients();
                if (!this.recipe.wasCooking() && Map2d.currentMap.stock.canSpawnIngredients(ingredients, true)) {
                    Map2d.currentMap.stock.spawnIngredients(ingredients, true);
                }
            }, { interactiveScale: false });
        }

        Map2d.currentMap.customers.on("onRecipesUpdated", this.onRecipesUpdated.bind(this), this);
    },

    createContent: function () {
        const isExactStage = Boolean(this.customer && this.customer.exactStageIngredients);
        this.customerIngredientViews = this.recipe.getIngredients().map((ingredient, index, ingredients) => {
            const ingredientView = new CustomerIngredientView(ingredient, CustomerIngredientView.TYPE_EXTENDEDVIEW, { isExactStage });
            ingredientView.setLocalZOrder(ingredients.length - index);
            return ingredientView;
        });

        const styles = cleverapps.styles.ExtendedCustomerView;
        const ingredientsLayout = new cleverapps.Layout(this.customerIngredientViews, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.ingredients.margin,
            padding: styles.ingredients.padding
        });

        const contentItems = [];
        if (this.recipe.getOrder().length > 0) {
            const width = Math.max(ingredientsLayout.width, styles.minWidth);

            // eslint-disable-next-line no-restricted-syntax
            const text = cleverapps.UI.generateTTFText(Messages.get("Customer.Orders"), cleverapps.styles.FONTS.EXTENDED_INFO_REWARDS_TEXT);
            text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
            text.fitTo(width);

            const decorationWidth = (width - text.width) / 2 - 2 * styles.rewards.text.decoration.padding;
            const decoration1 = new cc.Scale9Sprite(bundles.extended_customer_view.frames.extended_customer_reward_decor);
            const decoration2 = new cc.Scale9Sprite(bundles.extended_customer_view.frames.extended_customer_reward_decor);

            decoration1.setContentSize2(decorationWidth, styles.rewards.text.decoration.height);
            decoration2.setContentSize2(decorationWidth, styles.rewards.text.decoration.height);

            const title = new cleverapps.Layout([decoration1, text, decoration2], {
                direction: cleverapps.UI.HORIZONTAL,
                padding: styles.rewards.text.decoration.padding,
                margin: styles.rewards.text.decoration.margin
            });

            const provider = this.customer.unit.components.find((component) => component.getOrderRewards);

            this.rewardsList = new RewardsListComponent(Object.assign(this.recipe.prizesToRewards(), provider && provider.getOrderRewards()), {
                columns: 6,
                iconWrap: styles.rewards.iconWrap,
                noPrefix: true,
                hideTextForSingleReward: true,
                textDirection: cleverapps.UI.HORIZONTAL,
                textMargin: styles.rewards.margin,
                textPosition: styles.rewards.text,
                margin: styles.rewards.rewardsMargin,
                font: cleverapps.styles.FONTS.INFOVIEW_REWARD_TEXT,
                event: cleverapps.EVENTS.EARN.OTHER
            });

            cleverapps.UI.fitToBox(this.rewardsList, { width: width - 2 * styles.rewards.padding.x });

            contentItems.push(ingredientsLayout);
            contentItems.push(new cleverapps.Layout([title, this.rewardsList], {
                direction: cleverapps.UI.VERTICAL,
                padding: styles.rewards.padding,
                margin: styles.rewards.margin
            }));
        } else {
            const titleBg = cleverapps.UI.createScale9Sprite(bundles.extended_customer_view.frames.extended_customer_reward_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
            titleBg.setContentSize2(ingredientsLayout.width, styles.title.height);

            // eslint-disable-next-line no-restricted-syntax
            const text = cleverapps.UI.generateTTFText(Messages.get("Customer.Fix"), cleverapps.styles.FONTS.EXTENDED_INFO_TITLE_TEXT);
            text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
            text.fitTo(ingredientsLayout.width);
            titleBg.addChild(text);
            text.setAlignment(titleBg.width / 2, titleBg.height / 2);

            contentItems.push(titleBg);
            contentItems.push(ingredientsLayout);
        }

        const timer = CustomerInfoView.createOrderTimer(this.customer);
        if (timer) {
            timer.baseScale = styles.timer.scale;
            timer.setScale(styles.timer.scale);
            if (typeof HungryGamesCustomer !== "undefined" && typeof HungryGamesWindow !== "undefined") {
                cleverapps.UI.onClick(timer, () => {
                    const mission = HungryGamesCustomer.getMission();
                    if (!mission) {
                        return;
                    }

                    cleverapps.focusManager.display({
                        focus: "HungryGamesWindow",
                        action: function (f) {
                            new HungryGamesWindow(mission);
                            cleverapps.focusManager.onceNoWindowsListener = f;
                        }
                    });
                }, { swallowEvents: true });
            }

            contentItems.unshift(timer);
        }

        return new cleverapps.Layout(contentItems, {
            direction: cleverapps.UI.VERTICAL,
            padding: timer ? { top: styles.timerPadding } : undefined
        });
    },

    onRecipesUpdated: function () {
        if (this.recipe.wasCooking() || !this.isRunning()) {
            return;
        }
        let justGotReady = false;
        this.customerIngredientViews.forEach((ingredientView) => {
            if (ingredientView.onAmountChanged()) {
                justGotReady = true;
            }
        });

        if (justGotReady) {
            this.runAction(new cc.Sequence(
                new cc.ScaleTo(0.26, 0.93, 0.85).easing(cc.easeInOut(1)),
                new cc.ScaleTo(0.2, 1.05).easing(cc.easeInOut(1)),
                new cc.ScaleTo(0.067, 1).easing(cc.easeInOut(1))
            ));

            if (this.button) {
                this.button.removeFromParent();
            }
            this.button = this.createButton(true);
        }
    },

    createButton: function (silent) {
        let button = this.createBuyButton();
        const styles = cleverapps.styles.ExtendedCustomerView.button;
        if (!button && this.customer.isEnoughIngredientsForRecipe()) {
            button = new cleverapps.UI.Button({
                text: Messages.get("Customer.Exchange"),
                textVariant: "tiny",
                width: styles.width,
                height: styles.height,
                type: cleverapps.styles.UI.Button.Images.small_button_green,
                onClicked: () => {
                    this.customer.exchange();
                }
            });
            button.adviceTarget = Map2d.SPAWN;
        }

        if (button) {
            this.addChild(button);
            button.setAlignment(styles);

            if (!silent) {
                button.setVisible(false);
                button.runAction(new cc.Sequence(new cc.DelayTime(0.03), StandartAnimations.showUp(button)));
            }
        }

        this.setContentSize2(this.width, this.contentLayout.height + (button ? button.height : 0) + 2 * styles.paddingY);

        return button;
    },

    createHelpButton: function () {
        const guideOptions = this.customer.getGuideOptions();
        if (!guideOptions) {
            return;
        }
        const styles = cleverapps.styles.ExtendedCustomerView.helpButton;
        const unit = this.customer.unit;
        const button = new cleverapps.UI.HelpButton({
            callback: function () {
                cleverapps.focusManager.display({
                    stack: Map2dLocation.currentLocation.tutorial.checkConditions({ unit }) || cleverapps.tutorial.checkConditions({ unit }),
                    focus: "CustomerExtendedViewGuide",
                    action: function (f) {
                        new GuideWindow(guideOptions, unit);

                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            }
        });
        button.setAnchorPoint(0.5, 0.5);
        button.setAlignment(styles);
        button.resize(styles.width, styles.height);
        this.addChild(button);
    },

    createBuyButton: function () {
        if (this.customer.unit.getData().offIngredientsPurchase) {
            return;
        }

        const shoppingList = this.recipe.getShoppingList();
        if (!shoppingList.totalHard && !shoppingList.totalSoft) {
            return;
        }
        if (cleverapps.tutorial.checkConditions({ unit: this.customer.unit })) {
            return;
        }
        const totalHard = shoppingList.totalHard, totalSoft = shoppingList.totalSoft;

        const styles = cleverapps.styles.ExtendedCustomerView.button;
        const msg = (totalSoft ? ` @@${totalSoft}` : "") + (totalHard ? ` $$${totalHard}` : "");

        const button = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.small_button_blue,
            content: new TextWithIcon(msg),
            width: totalHard && totalSoft ? styles.buyWidthPair : styles.buyWidth,
            height: styles.height,
            onClicked: function () {
                if (!Map2d.currentMap.stock.canSpawnIngredients(shoppingList.hardItems.concat(shoppingList.softItems))) {
                    return;
                }

                const doPurchase = function () {
                    if (totalHard && !cleverapps.user.canTakeHard(totalHard)) {
                        cleverapps.user.onCantTakeGold(totalHard - cleverapps.user.gold);
                        return;
                    }

                    if (totalSoft && !cleverapps.user.canTakeSoft(totalSoft)) {
                        cleverapps.user.onCantTakeSoft();
                        return;
                    }

                    if (totalHard) {
                        cleverapps.user.spendHard(cleverapps.EVENTS.SPENT.RECIPE_INGREDIENT_ALL, totalHard);
                    }

                    if (totalSoft) {
                        cleverapps.user.spendSoft(cleverapps.EVENTS.SPENT.RECIPE_INGREDIENT_ALL, totalSoft);
                    }

                    Map2d.currentMap.stock.spawnIngredients(shoppingList.hardItems.concat(shoppingList.softItems));

                    if (this.customer.isEnoughIngredientsForRecipe()) {
                        button.removeFromParent();
                        this.customer.exchange();
                    }
                }.bind(this);

                doPurchase();
            }.bind(this)
        });
        return button;
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    INFOVIEW_REWARD_TEXT: {
        size: 26,
        name: "nostroke",
        color: cleverapps.styles.COLORS.COLOR_DARK_BROWN
    },

    EXTENDED_INFO_TITLE_TEXT: {
        size: 34,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    EXTENDED_INFO_REWARDS_TEXT: {
        size: 30,
        color: new cc.Color(123, 43, 25, 255)
    }
});

cleverapps.styles.ExtendedCustomerView = {
    minWidth: 320,

    content: {
        x: { align: "center" },
        y: { align: "top" }
    },

    title: {
        height: 58
    },

    timerPadding: 12,

    ingredients: {
        padding: {
            x: 30,
            top: 15,
            bottom: 4
        },

        margin: 10
    },

    rewards: {
        iconWrap: {
            width: 75,
            height: 75
        },

        rewardsMargin: { x: 10 },
        padding: {
            x: 10,
            bottom: 4
        },
        margin: 6,

        text: {
            x: { align: "right", dx: 0 },
            y: { align: "bottom", dy: -2 },
            decoration: {
                padding: 20,
                margin: 10,
                height: 5
            }
        }
    },

    timer: {
        scale: 1.2
    },

    button: {
        width: 160,
        height: 50,
        buyWidth: 150,
        buyWidthPair: 180,

        paddingY: 10,

        x: { align: "center" },
        y: { align: "bottom", dy: 14 }
    },

    helpButton: {
        x: { align: "left", dx: -10 },
        y: { align: "top", dy: 10 },
        width: 50,
        height: 50
    },

    pointer: {
        x: { align: "center" },
        y: -7
    }
};